(() => {
  const q = (s, c=document) => c.querySelector(s);
  const qa = (s, c=document) => [...c.querySelectorAll(s)];
  const root = window.BARE_THEME?.root || '/';
  const endpoint = (path) => `${root}${path.replace(/^\//,'')}`;

  const formatMoney = (cents, currency='EUR') => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format((cents || 0)/100); }
    catch { return `${((cents || 0)/100).toFixed(2)} ${currency}`; }
  };

  const mobileToggle = q('[data-mobile-menu-toggle]');
  const mobileMenu = q('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const overlay = q('[data-cart-overlay]');
  const drawerBody = q('[data-cart-body]');
  const subtotal = q('[data-cart-subtotal]');
  const countEls = () => qa('[data-cart-count]');

  function openCart(){ if(overlay){ overlay.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeCart(){ if(overlay){ overlay.classList.remove('is-open'); document.body.style.overflow=''; } }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openCart(); refreshCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
    if (e.target === overlay) closeCart();
  });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeCart(); });

  async function getCart(){
    const r = await fetch(endpoint('/cart.js'), {headers:{Accept:'application/json'}});
    if(!r.ok) throw new Error('Could not load cart');
    return r.json();
  }

  function renderCart(cart){
    countEls().forEach(el => el.textContent = cart.item_count > 0 ? cart.item_count : '');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
    if (!drawerBody) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="bare-cart__empty"><p>Your bag is empty.</p><a class="bare-link" href="'+(window.BARE_THEME?.root || '/')+'collections/all">Continue shopping</a></div>';
      return;
    }
    drawerBody.innerHTML = cart.items.map((item) => {
      const img = item.image ? `<img src="${item.image}" alt="">` : '<div style="width:76px;height:76px;background:var(--bare-soft)"></div>';
      return `<div class="bare-cart-line" data-cart-key="${item.key}">
        ${img}
        <div>
          <p class="bare-cart-line__title">${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : ''}</p>
          <div class="bare-cart-line__row">
            <div class="bare-cart-line__qty">
              <button type="button" data-cart-qty="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty="${item.quantity+1}" aria-label="Increase quantity">+</button>
            </div>
            <span>${formatMoney(item.final_line_price, cart.currency)}</span>
          </div>
          <button type="button" class="bare-cart-line__remove" data-cart-remove>Remove</button>
        </div>
      </div>`;
    }).join('');
  }

  async function refreshCart(){ try { renderCart(await getCart()); } catch(e) { console.error(e); } }
  window.BareCart = { refresh: refreshCart, open: openCart, close: closeCart };

  if (drawerBody) {
    drawerBody.addEventListener('click', async (e) => {
      const line = e.target.closest('[data-cart-key]'); if(!line) return;
      const key = line.dataset.cartKey;
      const qtyButton = e.target.closest('[data-cart-qty]');
      const remove = e.target.closest('[data-cart-remove]');
      if (!qtyButton && !remove) return;
      const quantity = remove ? 0 : Number(qtyButton.dataset.cartQty);
      const r = await fetch(endpoint('/cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key, quantity})});
      if(r.ok) renderCart(await r.json());
    });
  }

  qa('[data-bare-product]').forEach((section) => {
    const dataEl = q('[data-product-json]', section);
    if(!dataEl) return;
    let data; try { data = JSON.parse(dataEl.textContent); } catch { return; }

    const variants = data.variants || [];
    const currency = data.currency || 'EUR';
    const output = q('[data-stick-count]', section);
    const price = q('[data-product-total]', section);
    const notice = q('[data-product-notice]', section);
    const minus = q('[data-stick-minus]', section);
    const plus = q('[data-stick-plus]', section);
    const form = q('.bare-product-form', section);
    const variantInput = q('[data-selected-variant-id]', section);
    const buyNow = q('[data-buy-now]', section);
    const tierList = q('[data-bare-tier-list]', section);

    // Shopify Bundles exposes the bundle size as a variant option. This parser is
    // intentionally tolerant: it accepts option values such as "3", "3 sticks",
    // "Quantity: 3", or a numeric variant title.
    const quantityFromVariant = (variant) => {
      const candidates = [...(variant.options || []), variant.title].filter(Boolean);
      for (const candidate of candidates) {
        const text = String(candidate).trim();
        const exact = text.match(/^\s*(\d{1,2})\s*(?:sticks?)?\s*$/i);
        if (exact) return Number(exact[1]);
        const labelled = text.match(/(?:quantity|qty|sticks?)\s*[:\-]?\s*(\d{1,2})/i);
        if (labelled) return Number(labelled[1]);
      }
      return null;
    };

    const byQuantity = new Map();
    variants.forEach((variant) => {
      const qty = quantityFromVariant(variant);
      if (Number.isFinite(qty) && qty > 0 && !byQuantity.has(qty)) byQuantity.set(qty, variant);
    });

    const availableQuantities = [...byQuantity.keys()].sort((a,b) => a-b);
    if (!availableQuantities.length) {
      if (notice) notice.textContent = 'Bundle quantity variants were not found. Check the Shopify Bundles product options.';
      qa('[data-purchase-button]', section).forEach(btn => btn.disabled = true);
      return;
    }

    const configuredMax = Number(section.dataset.max || 24);
    const max = Math.min(configuredMax, availableQuantities[availableQuantities.length - 1]);
    const selected = variants.find(v => String(v.id) === String(data.selectedVariantId));
    let quantity = quantityFromVariant(selected) || availableQuantities[0] || 1;
    if (!byQuantity.has(quantity)) quantity = availableQuantities[0];

    const variantFor = (qty) => byQuantity.get(qty);
    const nextAvailable = (qty, direction) => {
      if (direction > 0) return availableQuantities.find(v => v > qty && v <= max) ?? qty;
      const lower = availableQuantities.filter(v => v < qty);
      return lower.length ? lower[lower.length - 1] : qty;
    };

    const renderTiers = () => {
      if (!tierList) return;
      const featured = [1,2,3].map(qty => [qty, variantFor(qty)]).filter(([,v]) => v);
      tierList.innerHTML = featured.map(([qty,v]) => `<li><span>${qty} ${qty === 1 ? 'stick' : 'sticks'}</span><span>${formatMoney(v.price, currency)}</span></li>`).join('');
    };

    const update = () => {
      const variant = variantFor(quantity);
      if(output) output.textContent = quantity;
      if(price && variant) price.textContent = formatMoney(variant.price, currency);
      if(variantInput && variant) variantInput.value = variant.id;
      if(minus) minus.disabled = nextAvailable(quantity, -1) === quantity;
      if(plus) plus.disabled = nextAvailable(quantity, +1) === quantity || quantity >= max;
      const ok = !!variant?.available;
      qa('[data-purchase-button]', section).forEach(btn => btn.disabled = !ok);
      if(notice) notice.textContent = ok ? '' : 'This quantity is currently unavailable.';
    };

    minus?.addEventListener('click',()=>{ quantity = nextAvailable(quantity, -1); update(); });
    plus?.addEventListener('click',()=>{ quantity = nextAvailable(quantity, +1); update(); });

    async function addSelected(goCheckout=false){
      const variant = variantFor(quantity);
      if(!variant || !variant.available) return;
      if(notice) notice.textContent = 'Adding…';
      const r = await fetch(endpoint('/cart/add.js'), {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:variant.id, quantity:1}]})
      });
      if(!r.ok){
        let message = 'Could not add this selection. Please try again.';
        try { const err = await r.json(); if (err?.description) message = err.description; } catch {}
        if(notice) notice.textContent = message;
        return;
      }
      if(goCheckout){ window.location.href = window.BARE_THEME?.checkoutUrl || '/checkout'; return; }
      if(notice) notice.textContent='Added to your bag.';
      await refreshCart(); openCart();
    }

    form?.addEventListener('submit',(e)=>{ e.preventDefault(); addSelected(false); });
    buyNow?.addEventListener('click',()=>addSelected(true));
    renderTiers();
    update();
  });

  refreshCart();
})();
